import NProgress from 'nprogress'
/**
 * Full list of supported functions

 * Currently the following queries are supported:

 * .find(int) - returns the object with the given id. (Odata: Products_(1)_)

 * .top(int) - returns the top x objects (Odata: Products/?$top=2) - Synonym: .take

 * .skip(int) - returns the objects skipped by the given value (Odata: Products/?$skip=2)

 * .first() - returns the first object which is found (Odata: Products/?$top=1)

 * .filter(string) - adds a filter string (o.js can converted simple JS-Syntax. If you need something complex use the plain Odata $filter syntax: see the Odata doc for more information) (Odata: Products/?$filter=Name eq 'Example') - Synonym: .where

 * .any(string, string) - applies an any filter to an resource (Odata: Products/?$filter=Categories/any(x:x/Name eq 'Test'))

 * .search(array, string) - builds up a search $filter. The first parameter defines the columns to search in the second the search word (e.g.: .search(['Name', 'Description'], 'Test'))

 * .orderBy(string, direction) - orders the data (Odata: Products/?$orderBy=Name)

 * .orderByDesc(string) - orders the data descending (Odata: Products/?$orderBy=Name)

 * .count() - only counts the result (Odata: Products/$count)

 * .inlineCount(string) - adds a inlinecount to the result. (Odata: Products/?$count=true)

 * .batch(string) - adds a second resource to the request (Odata: $batch)

 * .expand(string) - expands a related resource (Odata: Products/?$expand=ProductUnit)

 * .ref(string, string) - expands a related resource (Odata: Products/$ref=Categories(1))

 * .deleteRef(string, string) - expands a related resource (Odata: Products/$ref=Categories(1))

 * .post(object) - Post data to an endpoint

 * .patch(object) - PATCH data on an endpoint

 * .put(object) - PUT data on an endpoint

 * .remove(object) - DELETE data on an endpoint (You must define only one resource: e.g: Products(1) )
 */
import o from 'o.js'
import { SPR_TOKEN } from '@/constant'

o().config({
  endpoint: process.env.ODATA_ENDPOINT,
  json: true,
  version: 4,
  strictMode: true,
  start: () => {
    NProgress.start()
  },
  ready: () => {
    NProgress.done()
  },
  error: (status, msg) => {
    if (status === 401) {
      // window.localStorage.removeItem(SPR_TOKEN)
      if (!window.localStorage.getItem('NO_ALERT')) {
        window.localStorage.setItem('NO_ALERT', true)
        alert(msg, function() {
          window.localStorage.removeItem('NO_ALERT')
        })
      }
      window.location.href = '#/login'
      setTimeout(function() {
        window.location.reload()
      })
    }
    NProgress.done()
  },
  headers: [
    { name: 'Authorization', value: 'Bearer ' + window.localStorage.getItem(SPR_TOKEN) },
    { name: 'ApiKey', value: process.env.API_KEY },
  ],
  username: null,
  password: null,
  isAsync: true,
})

export default o



// WEBPACK FOOTER //
// ./src/odata.js